module.exports = __webpack_public_path__ + "static/media/LingoGuru.6f57a158.png";